export const environment = {
  production: true,
  apiURL: 'https://api.ark.com.mx/api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts